import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import * as S from './styles';
import { Tabs, TabPanel, TabList, Tab } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { MapContainer, TileLayer, Polygon, Marker, Popup, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import ViaCepService from '../../services/Viacep/ViaCepService';
import AddressService from '../../services/Viacep/AddressService';
import EstabelecimentoService from '../../services/Estabelecimento/EstabelecimentoService';
import secureStorage from '../../utils/SecureStorage';
import { MascaraCpfCnpj, ValidaCpf, ValidaCnpj, MascaraCep, MascaraTelefone, MascaraTelefoneFixo, ValidaEmail } from '../../utils/mask';
import axios from 'axios';
import useBuscaEstabelecimentoGlobal from '../../services/Estabelecimento/useBuscaEstabelecimentoGlobal';
import brasilapi from '../../services/brasilapi/brasilapi';
import { FaSearch } from 'react-icons/fa';

const estruturaInicial = {
  id: '',
  id_rede: secureStorage.getItem("id_r"),
  cpf_cnpj: '',
  nome_fantasia: '',
  Razao_Social: '',
  blocked: false,
  inactive: false,
  endereco: {
    rua: '',
    numero: '',
    complemento: '',
    bairro: '',
    cep: '',
    cidade: '',
    estado: '',
    latitude: '',
    longitude: '',
    poligonoEstabelecimento: []
  },
  contato: {
    telefone_fixo: '',
    celular: '',
    email: '',
    WhatsApp: '',
    observacoes: ''
  },
};

const ModalCadastroEstabelecimento = ({
  isOpen,
  onClose,
  estabelecimentoSelecionado,
  atualizarLista
}) => {
  const [estabelecimento, setEstabelecimento] = useState(estruturaInicial);
  const [activeTab, setActiveTab] = useState(0);
  const [erro, setErro] = useState('');
  const [showMapModal, setShowMapModal] = useState(false);
  const [polygonPoints, setPolygonPoints] = useState([]);
  const [enderecos, setEnderecos] = useState([]);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [addressFetched, setAddressFetched] = useState(false);
  const [fetchError, setFetchError] = useState(false);
  const [debounceTimer, setDebounceTimer] = useState(null);
  const [mapCenter, setMapCenter] = useState(null);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const [searchFilters, setSearchFilters] = useState({ cidade: '', nome: '' });
  const debounceBuscaRef = useRef();

  // Hook global
  const {
    searchResults: globalResults,
    loadregistros: loadGlobalEstabelecimentos,
    loading: searchLoading,
    error: searchError,
    temMais,
    resetBusca: resetBuscaGlobal
  } = useBuscaEstabelecimentoGlobal();

  useEffect(() => {
    if (estabelecimentoSelecionado) {
      setEstabelecimento(estabelecimentoSelecionado);
    } else {
      setEstabelecimento(estruturaInicial);
    }
    setErro('');
    setActiveTab(0);
  }, [estabelecimentoSelecionado, isOpen]);

  const handleChange = (e) => {
    let { name, value } = e.target;
    switch (name) {
      case 'contato.celular':
      case 'contato.WhatsApp':
        value = MascaraTelefone(value);
        break;
      case 'contato.telefone_fixo':
        value = MascaraTelefoneFixo(value);
        break;
      case 'endereco.cep':
        value = MascaraCep(value);
        break;
      case 'cpf_cnpj':
        value = EstabelecimentoService.applyCpfCnpjMask(value);
        break;
      case 'nome_fantasia':
      case 'Razao_Social':
      case 'endereco.rua':
      case 'endereco.bairro':
      case 'endereco.cidade':
      case 'endereco.estado':
      case 'endereco.complemento':
        value = value.toUpperCase();
        break;
      default:
        break;
    }
    if (name.includes('endereco.') || name.includes('contato.')) {
      const [parentKey, childKey] = name.split('.');
      setEstabelecimento(prevState => ({
        ...prevState,
        [parentKey]: {
          ...prevState[parentKey],
          [childKey]: value
        }
      }));
    } else {
      setEstabelecimento(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
    if (name === 'endereco.numero') {
      setAddressFetched(false);
      setFetchError(false);
    }
  };

  const onBlurCep = async (e) => {
    let { value } = e.target;
    const cep = value.replace(/\D/g, '');
    if (cep.length !== 8) return;
    try {
      const data = await ViaCepService.fetchAddress(cep);
      if (data.erro) {
        alert('CEP não encontrado.');
        return;
      }
      setEstabelecimento(prevState => ({
        ...prevState,
        endereco: {
          ...prevState.endereco,
          rua: data.logradouro,
          bairro: data.bairro,
          cidade: data.localidade,
          estado: data.uf,
          cep: value,
        }
      }));
      setAddressFetched(false);
      setFetchError(false);
    } catch (error) {
      alert('Erro ao buscar CEP: ' + error.message);
    }
  };

  const buscarCepEComparar = async () => {
    const { rua, cidade, estado } = estabelecimento.endereco;
    if (!rua || !cidade || !estado) {
      const missingFields = [];
      if (!rua) missingFields.push('rua');
      if (!cidade) missingFields.push('cidade');
      if (!estado) missingFields.push('estado');
      alert(`Preencha os seguintes campos antes de buscar: ${missingFields.join(', ')}`);
      return;
    }
    try {
      const enderecosEncontrados = await AddressService.fetchCepViaCEP(estado, cidade, rua);
      if (enderecosEncontrados.length > 0) {
        setEnderecos(enderecosEncontrados);
        setIsAddressModalOpen(true);
      } else {
        alert('Nenhum endereço encontrado para os dados fornecidos.');
      }
    } catch (error) {
      alert('Erro ao buscar endereço.');
    }
  };

  const handleOpenMap = () => {
    const { rua, numero, bairro, cidade, estado, poligonoEstabelecimento, latitude, longitude } = estabelecimento.endereco;
    if (latitude && longitude) {
      setPolygonPoints(
        poligonoEstabelecimento && poligonoEstabelecimento.length > 0
          ? poligonoEstabelecimento.map(point => [parseFloat(point[1]), parseFloat(point[0])])
          : []
      );
      setMapCenter({ latitude: parseFloat(latitude), longitude: parseFloat(longitude) });
      setShowMapModal(true);
    } else if (rua && numero && bairro && cidade && estado) {
      fetchLatLong(`${rua}, ${numero}, ${bairro}, ${cidade}, ${estado}`).then(() => {
        if (poligonoEstabelecimento && poligonoEstabelecimento.length > 0) {
          setPolygonPoints(poligonoEstabelecimento.map(point => [parseFloat(point[1]), parseFloat(point[0])]));
        } else {
          setPolygonPoints([]);
        }
        setShowMapModal(true);
      });
    } else {
      alert("Por favor, preencha o endereço completo ou forneça a latitude e longitude antes de abrir o mapa.");
    }
  };

  const handleCloseMap = () => {
    setShowMapModal(false);
  };

  const handleAddPoint = (point) => {
    if (polygonPoints.length < 4) {
      setPolygonPoints((prevPoints) => [...prevPoints, point]);
    }
  };

  const handleSavePolygon = () => {
    if (polygonPoints.length === 4) {
      const formattedPolygon = polygonPoints.map(point => [parseFloat(point[1]), parseFloat(point[0])]);
      formattedPolygon.push([formattedPolygon[0][0], formattedPolygon[0][1]]);

      // Calcular centroide
      const latSum = polygonPoints.reduce((sum, p) => sum + p[0], 0);
      const lngSum = polygonPoints.reduce((sum, p) => sum + p[1], 0);
      const centroide = [
        latSum / polygonPoints.length,
        lngSum / polygonPoints.length
      ];

      setEstabelecimento(prevState => ({
        ...prevState,
        endereco: {
          ...prevState.endereco,
          poligonoEstabelecimento: formattedPolygon,
          latitude: centroide[0],
          longitude: centroide[1]
        }
      }));
      setShowMapModal(false);
    } else {
      alert("Por favor, selecione exatamente quatro pontos para formar o polígono.");
    }
  };

  const handleClearPolygon = () => {
    setPolygonPoints([]);
  };

  const fetchLatLong = async (address, cep) => {
    const apiUrl = process.env.REACT_APP_API_open;
    const query = cep || address;
    if (!query) {
      setFetchError('Por favor, insira um endereço ou CEP válido.');
      return;
    }
    try {
      const response = await fetch(`${apiUrl}${query}`);
      if (!response.ok) {
        throw new Error(`Erro na API: ${response.status} - ${response.statusText}`);
      }
      const data = await response.json();
      if (data.length > 0 && data[0].lat && data[0].lon) {
        const { lat, lon } = data[0];
        setEstabelecimento(prevState => ({
          ...prevState,
          endereco: {
            ...prevState.endereco,
            latitude: lat,
            longitude: lon,
          }
        }));
        setAddressFetched(true);
        setFetchError(false);
      } else {
        setFetchError('Geolocalização não encontrada. Verifique os dados fornecidos.');
      }
    } catch (error) {
      setFetchError('Erro ao buscar geolocalização. Verifique sua conexão e tente novamente.');
    }
  };

  useEffect(() => {
    const { rua, numero, bairro, cidade, estado, cep, latitude, longitude } = estabelecimento.endereco;
    if (!latitude && !longitude && rua && numero && bairro && cidade && estado && cep && !addressFetched && !fetchError) {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      const address = `${rua}, ${numero}, ${bairro}, ${cidade}, ${estado}`;
      setDebounceTimer(setTimeout(() => fetchLatLong(address), 800));
    }
  }, [estabelecimento.endereco, addressFetched, fetchError]);

  const handleSelectEndereco = (enderecoSelecionado) => {
    setEstabelecimento((prevState) => ({
      ...prevState,
      endereco: {
        ...prevState.endereco,
        rua: enderecoSelecionado.logradouro,
        bairro: enderecoSelecionado.bairro,
        cidade: enderecoSelecionado.localidade,
        estado: enderecoSelecionado.uf,
        cep: enderecoSelecionado.cep,
      },
    }));
    setIsAddressModalOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cpf_cnpj = MascaraCpfCnpj(estabelecimento.cpf_cnpj);
    if (!ValidaCpf(cpf_cnpj) && !ValidaCnpj(cpf_cnpj)) {
      setErro('CPF/CNPJ inválido');
      return;
    }
    if (estabelecimento.contato.email && !ValidaEmail(estabelecimento.contato.email)) {
      setErro('Email inválido');
      return;
    }
    if (!estabelecimento.nome_fantasia) {
      setErro('Você precisa informar o Nome do Cliente');
      return;
    }
    if (!estabelecimento.endereco.rua) {
      setErro('Você precisa informar a Rua do Endereço');
      return;
    }
    if (!estabelecimento.endereco.numero) {
      setErro('Você precisa informar o Número do Endereço');
      return;
    }
    if (!estabelecimento.endereco.bairro) {
      setErro('Você precisa informar o Bairro do Endereço');
      return;
    }
    if (!estabelecimento.endereco.cep) {
      setErro('Você precisa informar o CEP do Endereço');
      return;
    }
    if (!estabelecimento.endereco.cidade) {
      setErro('Você precisa informar a Cidade do Endereço');
      return;
    }
    if (!estabelecimento.endereco.estado) {
      setErro('Você precisa informar o Estado do Endereço');
      return;
    }
    try {
      // Garante que o objeto tenha _id se vier apenas id
      const estabelecimentoToSave = { ...estabelecimento };
      if (!estabelecimentoToSave._id && estabelecimentoToSave.id) {
        estabelecimentoToSave._id = { $oid: estabelecimentoToSave.id };
      }
      // Corrige latitude/longitude para string se existirem
      if (estabelecimentoToSave.endereco) {
        if (typeof estabelecimentoToSave.endereco.latitude === 'number') {
          estabelecimentoToSave.endereco.latitude = String(estabelecimentoToSave.endereco.latitude);
        }
        if (typeof estabelecimentoToSave.endereco.longitude === 'number') {
          estabelecimentoToSave.endereco.longitude = String(estabelecimentoToSave.endereco.longitude);
        }
      }
      await EstabelecimentoService.saveEstabelecimento(estabelecimentoToSave);
      atualizarLista && atualizarLista();
      onClose();
    } catch (error) {
      setErro('Erro ao salvar o cadastro');
    }
  };

  const moveFocus = (e, nextFieldName) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const nextField = document.getElementsByName(nextFieldName)[0];
      if (nextField) {
        nextField.focus();
      }
    }
  };

  const latSum = polygonPoints.reduce((sum, p) => sum + p[0], 0);
  const lngSum = polygonPoints.reduce((sum, p) => sum + p[1], 0);
  const centroide = polygonPoints.length === 4 ? [latSum / 4, lngSum / 4] : null;
  const customIcon = new L.Icon({
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  });

  // Handler para clique no mapa
  const MapClickHandler = ({ onAddPoint }) => {
    useMapEvents({
      click: (e) => {
        onAddPoint([e.latlng.lat, e.latlng.lng]);
      }
    });
    return null;
  };

  // Dispara busca global ao abrir o modal de pesquisa
  useEffect(() => {
    if (isSearchModalOpen) {
      resetBuscaGlobal(searchFilters);
    }
    // eslint-disable-next-line
  }, [isSearchModalOpen]);

  // Dispara busca global ao digitar filtros (com debounce)
  useEffect(() => {
    if (!isSearchModalOpen) return;
    if (debounceBuscaRef.current) clearTimeout(debounceBuscaRef.current);
    debounceBuscaRef.current = setTimeout(() => {
      resetBuscaGlobal(searchFilters);
    }, 400);
    // eslint-disable-next-line
  }, [searchFilters.cidade, searchFilters.nome]);

  // Filtro frontend
  const filteredResults = globalResults.filter(e =>
    (!searchFilters.cidade || (e.endereco?.cidade || '').toLowerCase().includes(searchFilters.cidade.toLowerCase())) &&
    (!searchFilters.nome || (e.nome_fantasia || '').toLowerCase().includes(searchFilters.nome.toLowerCase()))
  );

  // Função para importar cadastro selecionado
  const handleImportCadastro = async (cadastro) => {
    try {
      // Adiciona o id_rede ao cadastro
      cadastro.id_rede = secureStorage.getItem("id_r");
      if (!cadastro.id_rede) {
        throw new Error("ID da rede não encontrado. Por favor, faça login novamente.");
      }

      // Aplica a máscara de CPF/CNPJ
      if (cadastro.cpf_cnpj) {
        cadastro.cpf_cnpj = EstabelecimentoService.applyCpfCnpjMask(cadastro.cpf_cnpj);
      }

      // Converte campos de texto para maiúsculas
      const textFields = [
        'nome_fantasia',
        'Razao_Social',
        'endereco.rua',
        'endereco.bairro',
        'endereco.cidade',
        'endereco.estado',
        'endereco.complemento'
      ];

      textFields.forEach(field => {
        if (field.includes('.')) {
          const [parent, child] = field.split('.');
          if (cadastro[parent] && cadastro[parent][child]) {
            cadastro[parent][child] = cadastro[parent][child].toUpperCase();
          }
        } else if (cadastro[field]) {
          cadastro[field] = cadastro[field].toUpperCase();
        }
      });

      // Se tiver apenas id, usa ele como _id
      if (cadastro.id && !cadastro._id) {
        cadastro._id = cadastro.id;
      }

      // Validação dos campos obrigatórios
      const requiredFields = [
        'nome_fantasia',
        'endereco.rua',
        'endereco.numero',
        'endereco.bairro',
        'endereco.cidade',
        'endereco.estado',
        'endereco.cep'
      ];

      const missingFields = requiredFields.filter(field => {
        if (field.includes('.')) {
          const [parent, child] = field.split('.');
          return !cadastro[parent] || !cadastro[parent][child];
        }
        return !cadastro[field];
      });

      if (missingFields.length > 0) {
        throw new Error(`Campos obrigatórios não preenchidos: ${missingFields.join(', ')}`);
      }

      // Adiciona data de atualização
      cadastro.data_update = new Date();

      await EstabelecimentoService.saveEstabelecimento(cadastro, true);
      setIsSearchModalOpen(false);
      atualizarLista && atualizarLista();
      onClose();
    } catch (error) {
      console.error('Erro ao importar estabelecimento:', error);
      setErro(error.message || 'Erro ao importar estabelecimento. Por favor, tente novamente.');
      setIsSearchModalOpen(false);
    }
  };

  const handleBuscaCNPJ = async () => {
    const cnpjValue = estabelecimento.cpf_cnpj.replace(/\D/g, '');
    if (cnpjValue.length !== 14) {
      setErro('CNPJ inválido para busca. Deve conter 14 dígitos.');
      return;
    }
    setErro(''); 
    try {
      const data = await brasilapi(cnpjValue);
      if (data) {
        setEstabelecimento(prevState => ({
          ...prevState,
          nome_fantasia: (data.nome_fantasia || '').toUpperCase(),
          Razao_Social: (data.razao_social || '').toUpperCase(),
          endereco: {
            ...prevState.endereco,
            rua: `${data.descricao_tipo_de_logradouro || ''} ${data.logradouro || ''}`.trim().toUpperCase(),
            numero: data.numero || '',
            bairro: (data.bairro || '').toUpperCase(),
            cep: data.cep ? MascaraCep(data.cep) : '',
            cidade: (data.municipio || '').toUpperCase(),
            estado: (data.uf || '').toUpperCase(),
            latitude: '', 
            longitude: '',
            poligonoEstabelecimento: []
          }
        }));
        setAddressFetched(false); 
        setFetchError(false);
      } else {
        setErro('Nenhum dado encontrado para o CNPJ informado.');
      }
    } catch (error) {
      console.error("Erro ao buscar CNPJ via BrasilAPI:", error);
      setErro(error.response?.data?.message || error.response?.data?.error || error.message || 'Erro ao buscar dados do CNPJ.');
    }
  };


  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        contentLabel="Cadastro de Estabelecimento"
        style={{ overlay: { zIndex: 2000 }, content: { padding: '32px 24px', maxWidth: 900, margin: 'auto', borderRadius: 10 } }}
      >
        <S.ModalHeader style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h2 style={{ margin: 0 }}>{estabelecimentoSelecionado ? 'Editar Estabelecimento' : 'Cadastrar Estabelecimento'}</h2>
          <button onClick={onClose} style={{ fontSize: 28, background: 'none', border: 'none', cursor: 'pointer', color: '#cf0505' }}>&times;</button>
        </S.ModalHeader>
        <form onSubmit={handleSubmit}>
          <Tabs selectedIndex={activeTab} onSelect={setActiveTab}>
            <TabList>
              <Tab>Estabelecimento</Tab>
              <Tab>Endereço</Tab>
              <Tab>Contato</Tab>
            </TabList>
            <TabPanel>
              <S.InputGroup>
                <S.Label>Nome Fantasia*</S.Label>
                <S.Input name="nome_fantasia" value={estabelecimento.nome_fantasia} onChange={handleChange} onKeyDown={e => moveFocus(e, 'Razao_Social')} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Razão Social</S.Label>
                <S.Input name="Razao_Social" value={estabelecimento.Razao_Social} onChange={handleChange} onKeyDown={e => moveFocus(e, 'cpf_cnpj')} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>CPF/CNPJ</S.Label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <S.Input
                    name="cpf_cnpj"
                    value={estabelecimento.cpf_cnpj}
                    onChange={handleChange}
                    maxLength={18}
                    onKeyDown={e => moveFocus(e, 'blocked')}
                    style={{ flexGrow: 1 }}
                  />
                  <S.Button
                    type="button"
                    onClick={handleBuscaCNPJ}
                    title="Buscar dados do CNPJ"
                    style={{ padding: '8px 10px', minWidth: 'auto', lineHeight: '1' }}
                  >
                    <FaSearch size={16} />
                  </S.Button>
                </div>
              </S.InputGroup>
              <S.InputGroup>
                <S.CheckboxContainer>
                  <S.Label>Bloquear:</S.Label>
                  <S.Checkbox name="blocked" type="checkbox" checked={estabelecimento.blocked} onChange={e => setEstabelecimento({ ...estabelecimento, blocked: e.target.checked })} />
                </S.CheckboxContainer>
              </S.InputGroup>
            </TabPanel>
            <TabPanel>
              <S.InputGroup>
                <S.Label>CEP</S.Label>
                <S.Input name="endereco.cep" value={estabelecimento.endereco.cep} onChange={handleChange} onBlur={onBlurCep} maxLength={9} onKeyDown={e => moveFocus(e, 'endereco.rua')} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Rua</S.Label>
                <S.Input name="endereco.rua" value={estabelecimento.endereco.rua} onChange={handleChange} onKeyDown={e => moveFocus(e, 'endereco.numero')} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Número</S.Label>
                <S.Input name="endereco.numero" value={estabelecimento.endereco.numero} onChange={handleChange} maxLength={10} onKeyDown={e => moveFocus(e, 'endereco.complemento')} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Complemento</S.Label>
                <S.Input name="endereco.complemento" value={estabelecimento.endereco.complemento} onChange={handleChange} onKeyDown={e => moveFocus(e, 'endereco.bairro')} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Bairro</S.Label>
                <S.Input name="endereco.bairro" value={estabelecimento.endereco.bairro} onChange={handleChange} onKeyDown={e => moveFocus(e, 'endereco.cidade')} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Cidade</S.Label>
                <S.Input name="endereco.cidade" value={estabelecimento.endereco.cidade} onChange={handleChange} onKeyDown={e => moveFocus(e, 'endereco.estado')} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Estado</S.Label>
                <S.Input name="endereco.estado" value={estabelecimento.endereco.estado} onChange={handleChange} maxLength={2} onKeyDown={e => moveFocus(e, 'endereco.latitude')} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Latitude</S.Label>
                <S.Input name="endereco.latitude" value={estabelecimento.endereco.latitude} onChange={handleChange} onKeyDown={e => moveFocus(e, 'endereco.longitude')} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Longitude</S.Label>
                <S.Input name="endereco.longitude" value={estabelecimento.endereco.longitude} onChange={handleChange} onKeyDown={e => moveFocus(e, 'contato.telefone_fixo')} />
              </S.InputGroup>
              <S.Button type="button" onClick={handleOpenMap}>Abrir Mapeamento</S.Button>
              <S.Button type="button" onClick={() => {
                setEstabelecimento((prevState) => ({
                  ...prevState,
                  endereco: {
                    ...prevState.endereco,
                    rua: prevState.endereco.rua.trim(),
                    cidade: prevState.endereco.cidade.trim(),
                    estado: prevState.endereco.estado.trim(),
                  },
                }));
                setTimeout(() => buscarCepEComparar(), 100);
              }} style={{ marginLeft: '10px' }}>
                Selecionar Endereço
              </S.Button>
            </TabPanel>
            <TabPanel>
              <S.InputGroup>
                <S.Label>Telefone fixo</S.Label>
                <S.Input name="contato.telefone_fixo" value={estabelecimento.contato.telefone_fixo} onChange={handleChange} onKeyDown={e => moveFocus(e, 'contato.celular')} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Celular</S.Label>
                <S.Input name="contato.celular" value={estabelecimento.contato.celular} onChange={handleChange} onKeyDown={e => moveFocus(e, 'contato.WhatsApp')} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>WhatsApp</S.Label>
                <S.Input name="contato.WhatsApp" value={estabelecimento.contato.WhatsApp} onChange={handleChange} onKeyDown={e => moveFocus(e, 'contato.email')} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Email</S.Label>
                <S.Input name="contato.email" value={estabelecimento.contato.email} onChange={handleChange} maxLength={255} onKeyDown={e => moveFocus(e, 'contato.observacoes')} />
              </S.InputGroup>
              <S.InputGroup>
                <S.Label>Observações</S.Label>
                <S.TextArea name="contato.observacoes" value={estabelecimento.contato.observacoes} onChange={handleChange} maxLength={250} onKeyDown={e => moveFocus(e, '')} />
              </S.InputGroup>
            </TabPanel>
          </Tabs>
          {erro && <S.Erro>{erro}</S.Erro>}
          <S.ButtonGroup>
            <S.Button type="submit">Salvar</S.Button>
            <S.Button type="button" onClick={onClose}>Cancelar</S.Button>
            <S.Button type="button" onClick={() => setIsSearchModalOpen(true)} style={{ background: '#1976d2', color: '#fff' }}>Pesquisar</S.Button>
          </S.ButtonGroup>
        </form>
      </Modal>
      {/* ModalEndereco fora do modal principal, com z-index maior */}
      <Modal
        isOpen={isAddressModalOpen}
        onRequestClose={() => setIsAddressModalOpen(false)}
        contentLabel="Selecione um endereço"
        style={{ overlay: { zIndex: 3000 }, content: { width: '80%', height: '80%', margin: 'auto', padding: '20px', borderRadius: '10px', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', position: 'relative', overflow: 'hidden', top: '10%' } }}
      >
        <S.ModalWrapper>
          <S.CloseButton onClick={() => setIsAddressModalOpen(false)}>Fechar</S.CloseButton>
          <S.ModalHeader>Selecione o endereço correto</S.ModalHeader>
          {enderecos.length > 0 ?
            <S.TableWrapper>
              <S.StyledTable2>
                <thead>
                  <tr>
                    <th>Logradouro</th>
                    <th>Bairro</th>
                    <th>Cidade</th>
                    <th>CEP</th>
                    <th>Complemento</th>
                  </tr>
                </thead>
                <tbody>
                  {enderecos.map((endereco, index) => (
                    <tr
                      key={index}
                      onClick={() => handleSelectEndereco(endereco)}
                      style={{
                        cursor: 'pointer',
                        transition: 'background-color 0.3s',
                      }}
                      onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#f1f1f1')}
                      onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'white')}
                    >
                      <td>{endereco.logradouro || '-'}</td>
                      <td>{endereco.bairro || '-'}</td>
                      <td>{endereco.localidade || '-'}</td>
                      <td>{endereco.cep || '-'}</td>
                      <td>{endereco.complemento || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </S.StyledTable2>
            </S.TableWrapper>
          : (
            <S.EmptyMessage>Nenhum endereço encontrado.</S.EmptyMessage>
          )}
        </S.ModalWrapper>
      </Modal>
      {/* Modal do mapa permanece fora do modal principal */}
      <Modal
        isOpen={showMapModal}
        onRequestClose={handleCloseMap}
        contentLabel="Selecione o Polígono"
        style={{ overlay: { zIndex: 3000 }, content: { width: '80%', height: '80%', margin: 'auto', zIndex: 3001 } }}
      >
        <h3 style={{ textAlign: 'center', fontSize: '1.3rem', marginBottom: 18 }}>
          Selecione quatro pontos no mapa para definir a área do estabelecimento
        </h3>
        <MapContainer
          center={[
            estabelecimento.endereco.latitude || -24.954257,
            estabelecimento.endereco.longitude || -53.467380
          ]}
          zoom={20}
          style={{ height: '400px', width: '100%' }}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Polygon positions={polygonPoints} />
          {polygonPoints.map((point, index) => (
            <Marker key={index} position={point} icon={customIcon}>
              <Popup>Ponto {index + 1}</Popup>
            </Marker>
          ))}
          {centroide && (
            <Marker position={centroide} icon={customIcon}>
              <Popup>Centro do polígono</Popup>
            </Marker>
          )}
          <MapClickHandler onAddPoint={handleAddPoint} />
        </MapContainer>
        <S.ButtonGroup style={{ marginTop: 24 }}>
          <S.Button onClick={handleSavePolygon}>Salvar Mapeamento</S.Button>
          <S.Button onClick={handleClearPolygon}>Limpar Mapeamento</S.Button>
          <S.Button onClick={handleCloseMap}>Fechar</S.Button>
        </S.ButtonGroup>
      </Modal>
      {/* Modal de Pesquisa Global */}
      <Modal
        isOpen={isSearchModalOpen}
        onRequestClose={() => setIsSearchModalOpen(false)}
        contentLabel="Pesquisar Estabelecimentos Globais"
        style={{ overlay: { zIndex: 3100 }, content: { width: '80%', height: '80%', margin: 'auto', padding: '20px', borderRadius: '10px', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', position: 'relative', overflow: 'hidden', top: '10%' } }}
      >
        <S.ModalWrapper>
          <S.CloseButton onClick={() => setIsSearchModalOpen(false)}>Fechar</S.CloseButton>
          <S.ModalHeader>Pesquisar Estabelecimentos Globais</S.ModalHeader>
          <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
            <S.Input
              placeholder="Cidade"
              value={searchFilters.cidade}
              onChange={e => setSearchFilters(f => ({ ...f, cidade: e.target.value }))}
              style={{ width: 180 }}
            />
            <S.Input
              placeholder="Nome Fantasia"
              value={searchFilters.nome}
              onChange={e => setSearchFilters(f => ({ ...f, nome: e.target.value }))}
              style={{ width: 220 }}
            />
          </div>
          {searchLoading ? <div>Carregando...</div> : searchError ? <S.Erro>{searchError}</S.Erro> : (
            <>
              <S.TableWrapper>
                <S.StyledTable2>
                  <thead>
                    <tr>
                      <th>Nome Fantasia</th>
                      <th>Cidade</th>
                      <th>Bairro</th>
                      <th>Endereço</th>
                      <th>Selecionar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredResults.map((cadastro, idx) => (
                      <tr key={cadastro._id?.$oid || cadastro._id || idx}>
                        <td>{cadastro.nome_fantasia || '-'}</td>
                        <td>{cadastro.endereco?.cidade || '-'}</td>
                        <td>{cadastro.endereco?.bairro || '-'}</td>
                        <td>{cadastro.endereco?.rua || '-'}, {cadastro.endereco?.numero || '-'}</td>
                        <td>
                          <S.Button type="button" onClick={() => handleImportCadastro(cadastro)} style={{ background: '#388e3c', color: '#fff' }}>Importar</S.Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </S.StyledTable2>
              </S.TableWrapper>
              {temMais && !searchLoading && (
                <div style={{ textAlign: 'center', marginTop: 16 }}>
                  <S.Button type="button" onClick={() => loadGlobalEstabelecimentos()} style={{ background: '#1976d2', color: '#fff' }}>
                    Carregar mais
                  </S.Button>
                </div>
              )}
            </>
          )}
        </S.ModalWrapper>
      </Modal>
    </>
  );
};

ModalCadastroEstabelecimento.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  estabelecimentoSelecionado: PropTypes.object,
  atualizarLista: PropTypes.func
};

export default ModalCadastroEstabelecimento; 